/* eslint-disable */
// 分销管理模块菜单配置
// 设计思路：采用模块化的菜单结构，便于权限控制和动态展示
// TODO: 考虑根据用户角色动态显示菜单项
const pre = '/distribution/';

export default {
  path: '/distribution',
  title: '分销管理',
  header: 'home',
  custom: 'i-icon-demo i-icon-demo-dashboard',
  children: [
    // 核心管理模块
    {
      path: `${pre}distributor`,
      title: '分销商管理',
      // TODO: 添加权限标识，如 permission: 'distribution:distributor:view'
      // 考虑：不同角色看到的功能可能不同
    },
    {
      path: `${pre}orders`,
      title: '分销订单',
      // 设计考虑：订单是分销业务的核心，需要突出显示
      // TODO: 考虑添加未处理订单数量的角标提示
    },
    {
      path: `${pre}commission`,
      title: '佣金管理',
      // 财务相关模块，需要更高的权限控制
      // TODO: 实现财务审批流程的集成
    },
    {
      path: `${pre}goods`,
      title: '分销商品',
      // 商品管理是分销体系的基础
      // TODO: 支持商品的批量导入和管理
    },
    {
      path: `${pre}invite`,
      title: '邀请关系',
    },
  ],
};